export const OTA_COMPETENCY_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Clinical Competency Program",
        subtitle: "INITIAL COMPETENCY ASSESSMENT SKILLS CHECKLIST— OCCUPATIONAL THERAPIST ASSISTANT",
        company: "INFINITE HOME HEALTH, INC"
    },

    // Page 1: Administrative/Documentation
    {
        id: 1,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate:",
        competencies: [
            {
                category: "1. Knowledge of Assessment Process:",
                items: [
                    "a. Assesses response to treatment",
                    "b. Other"
                ]
            },
            {
                category: "2. Documentation Skills: (accurate, timely, complete, legible)",
                items: [
                    "a. Progress notes, flow charts",
                    "b. Incident reporting",
                    "c. Other"
                ]
            },
            {
                category: "3. Adheres to POC",
                items: [
                    "a. Reviews POC prior to care",
                    "b. Performs services as ordered",
                    "c. Documents according to POC",
                    "d. Communicates/coordinates as appropriate",
                    "e. Other"
                ]
            },
            {
                category: "4. Knowledge of Medicare/State Guidelines:",
                items: [
                    "a. Criteria for participation",
                    "b. Skilled reimbursable visit",
                    "c. Other"
                ]
            },
            {
                category: "5. Reports and documents key information to Physician, DC planner, Clinician, Pharmacist, Supervisor"
            },
            {
                category: "6. Submits written summary reports as indicated"
            }
        ]
    },

    // Page 2: Administrative Continued
    {
        id: 2,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate: (continued)",
        competencies: [
            {
                category: "7. Attends/participates in case conferences as required"
            },
            {
                category: "8. Supply/HME requisition and management"
            },
            {
                category: "9. Infection Control Practices:",
                items: [
                    "a. Hand washing",
                    "b. Personal protective equipment",
                    "c. Exposure control plan",
                    "d. Equipment care, as appropriate",
                    "e. Other"
                ]
            },
            {
                category: "10. Patient home safety"
            },
            {
                category: "11. Other"
            },
            {
                category: "B. Patient Education:",
                items: [
                    "1. Develops/implement teaching plan",
                    "2. Evaluates effectiveness of teaching",
                    "3. Documents patient response",
                    "4. Other"
                ]
            },
            {
                category: "C. Clinical Skills—General:",
                items: [
                    "1. Vital Signs",
                    "2. Other"
                ]
            }
        ]
    },

    // Page 3: Skilled Treatments/Interventions
    {
        id: 3,
        type: 'section',
        title: "D. Skilled Treatments/Interventions:",
        competencies: [
            {
                category: "D. Skilled Treatments/Interventions:",
                items: [
                    "1. Teaches ADL/IADL Program",
                    "2. Work simplification and energy conservation",
                    "3. Teaches muscle reeducation program",
                    "4. Perceptual motor training",
                    "5. Fine motor training/dexterity training/gross motor training",
                    "6. Neuro-developmental training",
                    "7. Sensory enhancement (tactile, ocular, gustatory, Olfactory, proprioceptive, auditory, vestibular, kinesthesia)",
                    "8. Arranges orthotics/splinting",
                    "9. Arranges adaptive equipment",
                    "10. Teaches caregiver exercises/activities",
                    "11. Safety evaluation/environment adaption recommendations",
                    "12. Other"
                ]
            }
        ]
    },

    // Page 4: Comments & Signatures
    {
        id: 4,
        type: 'signature',
        title: "Comments & Signatures",
        fields: [
            { label: "Clinician Signature", name: "clinicianSignature" },
            { label: "Date", name: "clinicianDate", inputType: "date" },
            { label: "Evaluator Signature", name: "evaluatorSignature" },
            { label: "Date", name: "evaluatorDate", inputType: "date" }
        ]
    },

    // Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];

export const OTA_JOB_DESCRIPTION_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Certified Occupational Therapy Assistant",
        reportsTo: "Registered Occupational Therapist"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The certified occupational therapy assistant contracted through the Organization is responsible to the registered occupational therapist that is responsible for the implementation of standards of care for occupational therapy services and for adherence to all conditions outlined in the Service Agreement. The certified occupational therapy assistant performs only those services planned, delegated, and supervised by the registered occupational therapist."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            "Participates in the ongoing evaluation of patient's functional status (muscle function, endurance, visual coordination, written and verbal communication skills, self care ability, work capacity, etc.) as delegated by the registered occupational therapist. Participates in the ongoing evaluation of the home environment for hazards or barriers to more independent living as delegated by the registered occupational therapist.",
            "Participates in teaching new skills or retraining patients in once familiar daily activities that have been lost due to illness or injury, in accordance with organization policy.",
            "Maintains appropriate clinical records, clinical notes, and reports to the registered occupational therapist any changes in the patient's condition.",
            "Submits clinical documentation in accordance with Organization policy.",
            "Follows treatment program and goals for improved patient function as established by the registered occupational therapist. Documents patient's response to treatment plan and progress toward established goals.",
            "Maintains contact/communication with other personnel involved in the patient's care to promote coordinated, efficient care. Documents such communication in accordance with Organization policy.",
            "Attends and contributes to inservices, case conferences, and other meetings as required by Organization policy to ensure coordinated and comprehensive plans of care for the patients of the Organization.",
            "Identifies patient and family/caregiver needs for other home care services. Consults with the supervising registered occupational therapist and assists with necessary referrals, as appropriate.",
            "Participates in instructing patient's family/caregiver and other Organization health care personnel in patient's treatment regime as delegated by the registered occupational therapist.",
            "Is supervised by the registered occupational therapist no less than every thirty days. Documentation in the clinical record will reflect ongoing communication between the registered occupational therapist and certified occupational therapy assistant, the patient's condition, the patient's response to services provided by the assistant, any need to change the plan of care, and patient outcomes."
        ],
        generalStatement: "The above statements are only meant to be a representative summary of the major duties and responsibilities performed by incumbents of this job. The incumbents may be requested to perform job related tasks other than those stated in this description."
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Graduate of an occupational therapy assistant curriculum accredited by the American Occupational Therapy Association.",
            "Certified with the National Certification Examination of the American Occupational Therapy Association.",
            "Licensed by the State Board of Healing Arts in accordance with State licensure laws.",
            "A minimum of one year of clinical experience as a certified occupational therapy assistant.",
            "Demonstrates good verbal and written communication, and organization skills.",
            "Possesses and maintains current CPR certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
